import { Component, OnDestroy } from '@angular/core'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { Subscription } from 'rxjs/Subscription'
import { Configuracao } from '../../pkw-data/core/configuracao/configuracao.model'

@Component({
    selector: 'col-configuracao-integracao',
    templateUrl: './configuracao-integracao.component.html',
    styleUrls: ['./configuracao-integracao.component.scss'],
})
export class ConfiguracaoIntegracaoComponent implements OnDestroy {
    private routeSubscription: Subscription

    isPopupAvaAberto: boolean = true

    constructor(private router: Router, private route: ActivatedRoute) {
        this.redirectToChild().then(() => {
            this.routeSubscription = router.events
                .filter((event) => event instanceof NavigationEnd)
                .subscribe(() => {
                    this.redirectToChild()
                })
        })
    }

    ngOnDestroy() {
        this.routeSubscription.unsubscribe()
    }

    redirectToChild() {
        const configuracaoIntegracaoPorBandeira = this.route.snapshot.data
            .configuracaoIntegracaoPorBandeira as Configuracao
        const integracaoPorBandeira =
            configuracaoIntegracaoPorBandeira.getValor<boolean>()

        const childRoute = integracaoPorBandeira ? 'bandeira' : 'operadora'

        return this.router.navigate(['configuracao-integracao', childRoute], {
            replaceUrl: true,
        })
    }

    fecharPopupAva() {
        this.isPopupAvaAberto = false
    }
}



// WEBPACK FOOTER //
// ./src/app/configuracao/configuracao-integracao/configuracao-integracao.component.ts